import { render, staticRenderFns } from "./BisMenuJournal.vue?vue&type=template&id=46f6cdfd&scoped=true"
import script from "./BisMenuJournal.vue?vue&type=script&lang=js"
export * from "./BisMenuJournal.vue?vue&type=script&lang=js"
import style0 from "./BisMenuJournal.vue?vue&type=style&index=0&id=46f6cdfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6cdfd",
  null
  
)

export default component.exports